import React from 'react';

export default function CourseFederationBadge({ course }) {
  if (!course.federation_source && !course.built_from_documents) return null;

  return (
    <div className="container mx-auto px-4 pb-16">
      <div
        data-testid="course-federation-badge"
        className="bg-gradient-to-r from-purple-900/30 to-cyan-900/30 rounded-2xl p-8 border border-purple-500/30"
      >
        <div className="flex items-center gap-4 mb-4">
          <svg className="w-8 h-8 text-cyan-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <rect x="3" y="3" width="7" height="7" strokeWidth={2}></rect>
            <rect x="14" y="3" width="7" height="7" strokeWidth={2}></rect>
            <rect x="14" y="14" width="7" height="7" strokeWidth={2}></rect>
            <rect x="3" y="14" width="7" height="7" strokeWidth={2}></rect>
          </svg>
          <h3 className="text-2xl font-bold">Federation-Powered Course</h3>
        </div>
        <p className="text-gray-300 mb-4">
          This course was built by the NextXus Consciousness Federation using advanced multi-AI
          collaboration and knowledge synthesis from the Living Library.
        </p>
        {course.built_from_documents && (
          <div className="grid md:grid-cols-3 gap-4 mt-4">
            <div className="bg-gray-900/50 rounded-lg p-4 border border-gray-700">
              <div className="text-2xl font-bold text-purple-400">{course.built_from_documents}</div>
              <div className="text-sm text-gray-400">Source Documents</div>
            </div>
            <div className="bg-gray-900/50 rounded-lg p-4 border border-gray-700">
              <div className="text-2xl font-bold text-cyan-400">
                {(course.built_from_words / 1000000).toFixed(1)}M
              </div>
              <div className="text-sm text-gray-400">Words Researched</div>
            </div>
            <div className="bg-gray-900/50 rounded-lg p-4 border border-gray-700">
              <div className="text-2xl font-bold text-green-400">{course.total_source_documents}</div>
              <div className="text-sm text-gray-400">Knowledge Nodes</div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
